module.exports = __webpack_public_path__ + "static/media/carmen-pellicer.ec3183e0.png";